// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"3eaa4d99","207":"cc493171","323":"757df4ad","723":"71d34557","917":"5bf3abd0"}[chunkId] + ".chunk.js";
};